module.exports = __webpack_public_path__ + "img/6aa7c9e.svg";